import { usePortalName } from './usePortalName';

export function useIsClientPortal(): boolean {
  const portalName = usePortalName();
  return portalName ? portalName.indexOf('admin') > 0 : false;
}
